export default "__VITE_ASSET__zIO7IHe3__"